import { render } from "./CloudUploadIcon.svg?vue&type=template&id=daec91d4"
const script = {}
script.render = render

export default script